export default {
    title: 'Input',
    'add-value': 'Add value',
}